import React from 'react'
import Footer from './Footer'
import Navigation from './Navigation'

function Privarcy() {
  return (
    <>
    <Navigation/>
    <div className="container">
    <div className="entry-content wp-block-post-content has-global-padding is-layout-constrained wp-block-post-content-is-layout-constrained" bis_skin_checked="1">
    <p>Viimeksi päivitetty: 11. tammikuuta 2025</p>

    <p>https://finlandgesocial.com ("me," "meidän" tai "meitä") ylläpitää verkkosivustoa https://finlandgesocial.com (”Palvelu”).</p>

    <p>Tällä sivulla selitetään käytäntömme henkilötietojen keräämiseen, käyttöön ja luovuttamiseen liittyen, kun käytät Palveluamme.</p>

    <p>Olemme sitoutuneet suojaamaan yksityisyyttäsi. Käytämme tietojasi vain tämän tietosuojakäytännön mukaisesti.</p>

    <p>Käytämme henkilötietojasi tarjotaksemme ja parantaaksemme Palveluamme. Käyttämällä Palvelua hyväksyt tietojen keräämisen ja käytön tämän käytännön mukaisesti. Ellei tässä tietosuojakäytännössä toisin määritellä, käytetyillä termeillä on sama merkitys kuin käyttöehdoissamme, jotka ovat saatavilla osoitteessa https://finlandgesocial.com.</p>

    <h2 className="wp-block-heading">Tietojen kerääminen ja käyttö</h2>

    <p>Kun käytät Palveluamme, sinulta saatetaan pyytää tiettyjä henkilötietoja yhteydenottoa tai tunnistamista varten. Henkilötiedot voivat sisältää, mutta eivät rajoitu, seuraaviin:</p>
    <ul>
        <li>Koko nimi</li>
        <li>Sähköpostiosoite</li>
        <li>Puhelinnumero</li>
    </ul>

    <h2 className="wp-block-heading">Lokitiedot</h2>

    <p>Keräämme tietoja, joita selaimesi lähettää aina, kun käyt Palvelussamme ("Lokitiedot"). Lokitiedot voivat sisältää esimerkiksi laitteen IP-osoitteen, selaintyypin, selainversion, vierailemasi sivut, vierailun päivämäärän ja ajan, sivuilla vietetyn ajan sekä muita diagnostiikkatietoja.</p>

    <h2 className="wp-block-heading">Evästeet</h2>

    <p>Evästeet ovat pieniä tiedostoja, jotka tallennetaan laitteellesi ja voivat sisältää anonyymin yksilöivän tunnisteen. Käytämme evästeitä kerätäksemme tietoja kokemuksesi parantamiseksi. Voit määrittää selaimesi hylkäämään evästeet, mutta tämä voi rajoittaa tiettyjä Palvelun toimintoja.</p>

    <h2 className="wp-block-heading">Palveluntarjoajat</h2>

    <p>Voimme käyttää kolmansia osapuolia helpottamaan Palveluamme, suorittamaan siihen liittyviä tehtäviä tai auttamaan meitä analysoimaan, miten Palvelua käytetään. Nämä kolmannet osapuolet saavat käyttää tietojasi vain suorittaakseen tehtäviä puolestamme, ja heitä sitoo salassapitosopimus.</p>

    <h2 className="wp-block-heading">Turvallisuus</h2>

    <p>Henkilötietojesi turvallisuus on meille tärkeää. Vaikka käytämme alan standardien mukaisia käytäntöjä tietojesi suojaamiseksi, mikään tiedonsiirto- tai tallennusmenetelmä ei ole täysin turvallinen. Emme voi taata ehdotonta turvallisuutta, mutta pyrimme tarjoamaan korkeimman mahdollisen suojan.</p>

    <h2 className="wp-block-heading">Lasten yksityisyys</h2>

    <p>Palvelumme ei ole tarkoitettu alle 18-vuotiaille. Emme tietoisesti kerää henkilötietoja alaikäisiltä. Jos epäilet, että lapsi on antanut meille henkilötietoja, ota meihin yhteyttä, niin poistamme tiedot välittömästi.</p>

    <h2 className="wp-block-heading">Muutokset tähän tietosuojakäytäntöön</h2>

    <p>Voimme päivittää tätä tietosuojakäytäntöä ajoittain. Kannustamme käyttäjiä tarkistamaan tämän sivun säännöllisesti. Muutokset tulevat voimaan, kun ne julkaistaan täällä.</p>

    <h2 className="wp-block-heading">Tietojen analysointi</h2>

    <p>Finland Social Casino voi käyttää henkilötietojasi analysointiin ja käyttäjäprofiilien luomiseen parantaakseen markkinointistrategioita. Tällaiset toiminnot voivat sisältää käyttäytymisen luokittelua, mieltymysten analysointia ja käyttäjäkokemuksen optimointia. Joitakin prosesseja voidaan suorittaa automaattisesti ilman suoraa ihmisen valvontaa.</p>

    <h2 className="wp-block-heading">Ota yhteyttä</h2>

    <p>Jos sinulla on kysymyksiä tai huolenaiheita tästä tietosuojakäytännöstä, ota meihin yhteyttä osoitteessa support@finlandgesocial.com.</p>
</div>

</div>

    <Footer/>
    
    </>
  )
}

export default Privarcy